<template>
  <!-- 自定义tabbar 保留你所有原有属性 -->
  <van-tabbar
    v-model="active"
    :style="{ backgroundColor: datas.backgroundColor }"
    :fixed="false"
    :placeholder="true"
    :border="false"
    :active-color="datas.activeColor"
    :inactive-color="datas.inactiveColor"
    :before-change="handleBeforeChange"
    class="custom-tabbar"
  >
    <van-tabbar-item
      v-for="(item, index) in datas.iconList"
      :key="index"
      :name="item.iconText"
      :dot="item.isDot"
      :class="{ 'middle-tab-item': index === midIndex }"
    >
      <span>{{ item.iconText }}</span>
      <template #icon="props">
        <div
          v-if="props.active"
          :class="{ 'center-icon-active': index === midIndex }"
        >
          <i
            v-if="item.iconPic.includes('iconfont')"
            :class="item.iconPic"
            :style="index === midIndex ? 'font-size: 30px' : 'font-size: 25px'"
          ></i>
          <van-icon
            v-else
            :name="item.iconPic"
            :color="datas.activeColor"
            :size="index === midIndex ? 12 : 28"
          />
        </div>
        <div v-else>
          <i
            v-if="item.inactive.includes('iconfont')"
            :class="item.inactive"
            :style="index === midIndex ? 'font-size: 30px' : 'font-size: 25px'"
          ></i>
          <van-icon
            v-else
            :name="item.inactive"
            :color="datas.inactiveColor"
            :size="index === midIndex ? 32 : 28"
          />
        </div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: "tabbar3",
  props: {
    datas: Object,
    disabled: Boolean,
  },
  data() {
    return {
      active: 0, // 当前选中活动
    };
  },
  created() {
    console.log("第三种底部导航栏组件获取config", this.datas);
  },
  mounted() {},
  methods: {
    // 切换前的拦截方法 - 保留你原有禁止切换逻辑
    handleBeforeChange() {
      return false;
    },
  },
  computed: {
    // ✅ 你的原有计算属性，不用改，逻辑正确，完美计算中间索引
    midIndex() {
      // 3个项→1，5个项→2，4个项→1，2个项→1 自动适配所有长度
      return Math.floor((this.datas.iconList || []).length / 2);
    },
  },
};
</script>

<style lang="scss" scoped>
// 保留你原有所有样式
.van-tabbar {
  padding-bottom: 5px;
}
.tabBar {
  // width: 100%;
  // position: relative;
  // bottom: 0px;
  // left: 0px;
  // z-index: 2;
}

.tabbar-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.tabbar-icon.center {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10rpx;
  border-radius: 50%;
}

.tabbar-text {
  font-size: 12px;
  color: #8c8c8c;
}

.active-icon {
  background-color: #3282f6;
}

.active-text {
  color: #3282f6;
}

//  ============中间项的自定义样式 (全部在这里，重点！) ============
// 深度作用域，穿透vant的默认样式，因为是scoped必须加:deep()
.custom-tabbar {
  // 1. 中间项的核心样式 - 向上凸起+居中+高度自适应
  :deep(.van-tabbar-item.middle-tab-item) {
    background-color: #3282f6;
    color: #fff;
    border-radius: 50%;
    height: 66px;
    position: relative;
    top: -15px; // 向上凸起的距离，数值越大凸越高，可自定义
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // 让凸起的按钮不会被遮挡
    z-index: 10;
  }

  // 2. 中间项的图标外层容器 - 圆形背景+阴影+大小，视觉突出
  :deep(.middle-tab-item .van-tabbar-item__icon) {
    color: #fff;
    // width: 60px;
    // height: 60px;
    // border-radius: 50%; // 圆形
    // background-color: #ffffff; // 按钮底色，可改成你的datas.backgroundColor
    // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); // 轻微阴影增强立体感
    // display: flex;
    // align-items: center;
    // justify-content: center;
    margin-bottom: 5px;
  }

  // 3. 中间项的文字样式 - 选中/未选中都高亮，和图标呼应
  :deep(.middle-tab-item .van-tabbar-item__text) {
    font-size: 12px;
    margin-top: 8px;
    font-weight: 500;
    color: #fff;
  }

  // 4. 中间项激活图标的背景色 (可选，比如选中后圆形按钮变色)
  :deep(.center-icon-active) {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: red; // 绑定你传入的激活色，自动适配
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
